import { useLocale } from 'next-intl';
import React from 'react';

function CartRule({ rule }) {
  const locale = useLocale();
  const name = rule?.labels?.at(locale === 'ar' ? 1 : 2) || rule?.name || '';
  return (
    <div
      key={`rule-${rule?.rule_id}-${name}`}
      className={`flex h-6 items-center rounded-md bg-[#ffe8e8] px-2 text-xs text-[#c62828] ${name ? 'visible' : 'invisible'}`}
    >
      {name}
    </div>
  );
}

function CartRules({
  rules = [],
  isPdp = false,
  showBulkDiscount = false,
  isTopSelling,
  showOfferLabel = true,
}) {
  const bulkDiscount = {
    rule_id: `bulk-discount-label`,
    labels: [, 'خصم الجملة', 'Bulk Discount'],
    name: 'Bulk Discount',
  };
  return showOfferLabel ? (
    <div
      className={`${isPdp ? 'w-fit' : 'w-full'} ${isTopSelling ? 'w-full scale-90' : ''}`}
    >
      <div
        className={`flex flex-wrap gap-2 ${isPdp ? 'justify-end' : 'justify-center'} ${isTopSelling ? 'justify-start' : ''}`}
      >
        {showBulkDiscount ? <CartRule rule={bulkDiscount} /> : null}
        {(rules || [])?.map((rule) => (
          <CartRule key={rule?.rule_id} rule={rule} />
        ))}
      </div>
    </div>
  ) : null;
}

export default CartRules;
